'use strict';
var $ = window.jQuery;
var base = require('../common/base-url');
var validateTextField = require('../common/validate-textfield');
var validateEmail = require('../common/validate-email');
require('../SmartNotification.min.js');

module.exports = {
	init: function () {
		if (window.jQuery('#personal-profile').length > 0) {
			window.jQuery('#personal-profile').on('click', '.confirm', function (e) {
				var $this = window.jQuery(this);
				var msg = $this.data('confirm');
				var deleteurl = $this.data('deleteurl');

				window.jQuery.SmartMessageBox(
					{
						title: 'Confirm Delete',
						content: msg,
						buttons: '[Cancel][DELETE]'
					},
					function (btn) {
						if (btn === 'DELETE') {
							document.location.href = deleteurl;
						}
					}
				);
			});
			window.jQuery('#editEmailButton').click(editEmailModal);
		}
		// Hide update button for sections that have no editable fields
		if (
			window.jQuery('.btn-profile-editable').closest('.panel-profile').find('.panel-profile-editable').children()
				.length == 0
		) {
			window.jQuery('.btn-profile-editable').parent().hide();
		}

		window.jQuery('input#profileImageURL').on('uploadSuccess', function (e, files) {
			// submit the hidden form to tell the profile the use updated their profile image
			window.jQuery('form#updateProfileImage').submit();
		});
	}
};

function editEmailModal() {
	var link = window.jQuery(this);
	var profileGuid = link.data('profileid');
	var url = base + '/profile/changeemail/profileGuid/' + profileGuid;
	window.jQuery('#editEmail .modal-content').load(url, function (response, status, xhr) {
		if (status === 'error') {
			window.jQuery('#editEmail .modal-content').html('There was an error loading the edit email window');
		} else {
			window.jQuery('#editEmail .modal-content').removeClass('text-align-center');
			window.jQuery('#changeEmailForm').on('submit', requestEmailChange);
		}
	});
}
function requestEmailChange(e) {
	e.preventDefault();
	var error = false;
	error = validateTextField('.requireText');
	if (error) {
		return false;
	}
	const $submit = window.jQuery('#changeEmailForm button[type=submit]');
	if (validateEmail('#newEmailAddress', 'emailIsValid', '#changeEmailForm', $submit)) {
		//is valid email address
		if (window.jQuery('#newEmailAddress').val() === window.jQuery('#confEmailAddress').val()) {
			isUniqueEmail(window.jQuery('#newEmailAddress').val());
		} else {
			$submit.prop('disabled', false).text('Send Verification');
			d;
			window.jQuery('#confEmailAddress').closest('.errorContainer').addClass('error');
		}
	} else {
		return false;
	}
	return false;
}
function isUniqueEmail(newEmail) {
	window.jQuery
		.ajax({
			url: base + '/profile/validateUniqueEmailAddress?emailAddress=' + encodeURIComponent(newEmail),
			contentType: 'application/json; charset=utf-8',
			type: 'POST',
			dataType: 'json'
		})
		.fail(function (jqXHR, textStatus, errorMessage) {})
		.done(function (data, textStatus, jqXHR) {
			if (data.ISUNIQUE === true) {
				makeRequest();
			} else {
				window.jQuery('#newEmailAddress').closest('.errorContainer').addClass('error');
			}
		});
}
function makeRequest() {
	window.jQuery
		.ajax({
			url: base + '/profile/requestEmailChange?' + window.jQuery('#changeEmailForm').serialize(),
			contentType: 'application/json; charset=utf-8',
			type: 'POST',
			dataType: 'json'
		})
		.fail(function (jqXHR, textStatus, errorMessage) {})
		.done(function (data, textStatus, jqXHR) {
			window.location.href = base + '/profile/emailchangerequested';
		});
}
